import { HttpParams } from '@angular/common/http';

export class AppliedChargesFilter {

    partnerId: string | undefined;
    processedFileId: number | undefined;
    from: Date | string | undefined;
    to: Date | string | undefined;
    chargeStatus: 'charged' | 'not_charged' | undefined;

    constructor(filter?: AppliedChargesFilter) {
        if (filter) {
            this.partnerId = filter.partnerId;
            this.processedFileId = filter.processedFileId;
            this.from = filter.from;
            this.to = filter.to;
            this.chargeStatus = filter.chargeStatus;
        }
    }

    getHttpParams(httpParams = new HttpParams()): HttpParams {
        if (this.partnerId) {
            httpParams = httpParams.set('partnerId', this.partnerId.toString());
        }
        if (this.processedFileId) {
            httpParams = httpParams.set('processedFileId', this.processedFileId.toString());
        }
        if (this.from && this.from !== '') {
            httpParams = httpParams.set('from', this.from.toString());
        }
        if (this.to && this.to !== '') {
            httpParams = httpParams.set('to', this.to.toString());
        }
        if (this.chargeStatus) {
            httpParams = httpParams.set('chargeStatus', this.chargeStatus);
        }
        return httpParams;
    }
}
